import React from "react";
import { Column } from "@ant-design/plots";

const VerticalBar = ({ sliderValue = [0.5, 1], xField = "Year", yField = "Citations", ...props }) => {
  const config = {
    ...props,
    xField,
    yField,
    height: 250,
    xAxis: {
      label: {
        autoRotate: false,
      },
    },
    ...(!!sliderValue ? { slider: { x: { values: sliderValue } } } : {}),
  };
  return <Column {...config} />;
};

export default VerticalBar;
